import { AUTH } from '../constants/actionTypes';

import * as api from '../api/index.js';

export const signin = (formData, history) => async (dispatch) => {
  try {
    
    const { data } = await api.signIn(formData);
    dispatch({ type: AUTH, data });
    history.push("/")
  
  } catch (error) {
    console.log(error.message);
  }
};

export const signup = (formData, history) => async (dispatch) => {
  try {
    console.log('form data ==> ',formData)
    const { data } = await api.signUp(formData);
    console.log('data ==> ',data)
    dispatch({ type: AUTH, data });
    history.push("/")
  
  } catch (error) {
    console.log(error.message);
  }
};